import { useEffect, useRef } from 'react';

export const useUpdateEffect = (effect, deps) => {
  const first = useRef(true);

  useEffect(() => {
    if (first.current) {
      first.current = false;

      return;
    }

    return effect();
  }, deps);
};
